'use client';
import React, { useEffect, useState } from 'react';
import { useCheckoutStore } from '../../store/checkoutStore';

// BACKEND INTEGRATION POINT: Replace with environment variable
// process.env.NEXT_PUBLIC_TELEGRAM_CHANNEL_LINK
const TELEGRAM_CHANNEL_LINK = 'https://t.me/x_luminary';

export default function SuccessStep() {
  const { txHash, reset } = useCheckoutStore();
  const [countdown, setCountdown] = useState(5);
  const [redirected, setRedirected] = useState(false);

  useEffect(() => {
    if (countdown <= 0) {
      setRedirected(true);
      window.location.href = TELEGRAM_CHANNEL_LINK;
      return;
    }
    const timer = setTimeout(() => setCountdown((c) => c - 1), 1000);
    return () => clearTimeout(timer);
  }, [countdown]);

  const handleManualRedirect = () => {
    setRedirected(true);
    window.location.href = TELEGRAM_CHANNEL_LINK;
  };

  return (
    <div className="flex flex-col items-center gap-6 py-4 animate-fade-in text-center">
      {/* Success icon */}
      <div className="relative">
        <div className="w-20 h-20 rounded-full flex items-center justify-center"
          style={{ background: 'rgba(34, 197, 94, 0.1)', border: '2px solid rgba(34, 197, 94, 0.4)' }}>
          <svg className="w-10 h-10 text-green-400" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2.5} d="M5 13l4 4L19 7" />
          </svg>
        </div>
        <div className="absolute inset-0 rounded-full animate-ping-slow"
          style={{ background: 'rgba(34, 197, 94, 0.1)' }} />
      </div>

      {/* Title */}
      <div className="flex flex-col gap-2">
        <h3 className="text-2xl font-extrabold text-foreground">Payment Confirmed!</h3>
        <p className="text-sm text-muted-foreground leading-relaxed max-w-xs mx-auto">
          Your Bitcoin transaction has been verified on-chain. Your Telegram access has been dispatched.
        </p>
      </div>

      {/* TX details */}
      <div className="w-full rounded-xl p-4 flex flex-col gap-3 text-left"
        style={{ background: 'rgba(34, 197, 94, 0.05)', border: '1px solid rgba(34, 197, 94, 0.2)' }}>
        <div className="flex items-center justify-between">
          <span className="text-xs font-semibold text-muted-foreground uppercase tracking-wider">Transaction ID</span>
          <span className="text-xs text-green-400 font-semibold">Verified ✓</span>
        </div>
        <p className="font-mono-data text-xs text-foreground break-all leading-relaxed">
          {txHash || '4a5e1e4baab89f3a32518a88c31bc87f618f76673e2cc77ab2127b7afdeda33b'}
        </p>
      </div>

      {/* Redirect countdown */}
      <div className="w-full rounded-xl p-5 flex flex-col items-center gap-4"
        style={{ background: 'rgba(245, 158, 11, 0.06)', border: '1px solid rgba(245, 158, 11, 0.2)' }}>
        <div className="flex items-center gap-3">
          <div className="w-10 h-10 rounded-full flex items-center justify-center text-2xl"
            style={{ background: 'rgba(245, 158, 11, 0.1)', border: '1px solid rgba(245, 158, 11, 0.2)' }}>
            ✈️
          </div>
          <div className="text-left">
            <p className="text-sm font-bold text-foreground">Redirecting to Telegram</p>
            <p className="text-xs text-muted-foreground">Your access link is waiting in the channel</p>
          </div>
        </div>

        {!redirected ? (
          <div className="flex flex-col items-center gap-3 w-full">
            <div className="w-full rounded-full h-2 bg-muted overflow-hidden">
              <div
                className="h-full rounded-full transition-all duration-1000"
                style={{
                  background: 'linear-gradient(90deg, #f59e0b, #fbbf24)',
                  width: `${((5 - countdown) / 5) * 100}%`,
                }}
              />
            </div>
            <p className="text-sm text-muted-foreground">
              Redirecting in <span className="text-primary font-bold">{countdown}</span> seconds...
            </p>
          </div>
        ) : (
          <p className="text-sm text-green-400 font-semibold">Redirecting now...</p>
        )}

        <button
          onClick={handleManualRedirect}
          className="btn-primary w-full py-3.5 text-sm font-bold flex items-center justify-center gap-2"
        >
          Go to Telegram now
          <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M10 6H6a2 2 0 00-2 2v10a2 2 0 002 2h10a2 2 0 002-2v-4M14 4h6m0 0v6m0-6L10 14" />
          </svg>
        </button>
      </div>

      <button
        onClick={reset}
        className="text-xs text-muted-foreground hover:text-foreground transition-colors duration-150"
      >
        Close
      </button>
    </div>
  );
}